import React, { useState } from "react";
import { getSampleContracts } from "./services/contractsService";
import OpportunitiesList from "./components/OpportunitiesList";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { FileText, Search, List } from "lucide-react";

export default function ContractsDashboard() {
  const [activeTab, setActiveTab] = useState("opportunities");
  const contracts = getSampleContracts();

  const tabs = [
    { id: "opportunities", label: "Opportunities", icon: Search },
    { id: "contracts", label: "Contracts", icon: FileText },
  ];

  const getStatusVariant = (status) => {
    switch (status.toLowerCase()) {
      case "active":
        return "success";
      case "draft":
        return "secondary";
      case "expired":
        return "destructive";
      default:
        return "outline";
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Contracts</h1>
        <p className="text-muted-foreground">
          View contract opportunities and manage contracts
        </p>
      </div>

      <div className="flex gap-2 border-b">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <Button
              key={tab.id}
              variant="ghost"
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                "rounded-none border-b-2 border-transparent",
                activeTab === tab.id && "border-primary"
              )}
            >
              <Icon className="h-4 w-4 mr-2" />
              {tab.label}
            </Button>
          );
        })}
      </div>

      {activeTab === "opportunities" && <OpportunitiesList />}

      {activeTab === "contracts" && (
        <Card>
          <CardHeader>
            <CardTitle>Contract List</CardTitle>
            <CardDescription>
              {contracts.length} contracts found
            </CardDescription>
          </CardHeader>
          <CardContent>
            {contracts.length === 0 ? (
              <p className="text-muted-foreground text-center py-8">
                No contracts yet - coming soon.
              </p>
            ) : (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>ID</TableHead>
                    <TableHead>Title</TableHead>
                    <TableHead>Status</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {contracts.map((c) => (
                    <TableRow key={c.id}>
                      <TableCell className="font-medium">{c.id}</TableCell>
                      <TableCell>{c.title}</TableCell>
                      <TableCell>
                        <Badge variant={getStatusVariant(c.status)}>
                          {c.status}
                        </Badge>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
